import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import BrandBanner from "./components/BrandBanner";
import WhyChooseSection from "./components/WhyChooseSection";
import ArticlesSection from "./components/ArticlesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://hipobuy2026.net";

const homeSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "HipoBuy 2026",
    "url": SITE_URL,
    "description": "HipoBuy 2026 – best hipobuy spreadsheet 2026. Your ultimate destination for premium fashion including shoes, hoodies, t-shirts, jackets, pants, headwear, sets, underwear, jerseys and accessories.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://repsw2c.com/search?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "HipoBuy 2026",
    "url": SITE_URL,
    "logo": "https://static.readdy.ai/image/751042991eee80e3d0f5ce87d83ca658/78871cc3cb98add911b4c909beefd628.png",
    "sameAs": ["https://repsw2c.com/"],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": "English"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "HipoBuy 2026 Fashion Categories",
    "description": "Browse all premium fashion categories available on HipoBuy 2026",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Shoes", "url": "https://repsw2c.com/category-911-Shoes.html" },
      { "@type": "ListItem", "position": 2, "name": "Hoodies/Sweaters", "url": "https://repsw2c.com/search-912/name/Shoes.html" },
      { "@type": "ListItem", "position": 3, "name": "T-Shirts", "url": "https://repsw2c.com/search-913/name/Shoes.html" },
      { "@type": "ListItem", "position": 4, "name": "Jackets", "url": "https://repsw2c.com/search-914/name/Shoes.html" },
      { "@type": "ListItem", "position": 5, "name": "Pants/Shorts", "url": "https://repsw2c.com/search-915/name/Shoes.html" },
      { "@type": "ListItem", "position": 6, "name": "Headwear", "url": "https://repsw2c.com/search-916/name/Shoes.html" },
      { "@type": "ListItem", "position": 7, "name": "Sets", "url": "https://repsw2c.com/search-917/name/Shoes.html" },
      { "@type": "ListItem", "position": 8, "name": "Underwear/Underpants", "url": "https://repsw2c.com/search-918/name/Shoes.html" },
      { "@type": "ListItem", "position": 9, "name": "Jersey", "url": "https://repsw2c.com/search-919/name/Shoes.html" },
      { "@type": "ListItem", "position": 10, "name": "Accessories", "url": "https://repsw2c.com/search-920/name/Shoes.html" }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is HipoBuy 2026?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "HipoBuy 2026 is a premium fashion shopping platform offering top-quality clothing, shoes, and accessories at competitive prices with fast worldwide shipping."
        }
      },
      {
        "@type": "Question",
        "name": "How does HipoBuy shipping work?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "HipoBuy 2026 offers worldwide shipping with multiple delivery options. Orders are processed within 1-3 business days and delivered within 7-20 business days depending on your location."
        }
      },
      {
        "@type": "Question",
        "name": "What payment methods does HipoBuy accept?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "HipoBuy 2026 accepts major credit cards, PayPal, and other secure payment methods to ensure safe and convenient transactions."
        }
      },
      {
        "@type": "Question",
        "name": "Can I return items purchased on HipoBuy?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, HipoBuy 2026 offers a return policy for eligible items. Please review the return policy page for detailed information on conditions and procedures."
        }
      }
    ]
  }
];

export default function Home() {
  useEffect(() => {
    const existingScripts = document.querySelectorAll('script[data-schema="home"]');
    existingScripts.forEach((s) => s.remove());

    homeSchemas.forEach((schema, i) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-schema", "home");
      script.setAttribute("data-schema-index", String(i));
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-schema="home"]').forEach((s) => s.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <BrandBanner />
        <WhyChooseSection />
        <ArticlesSection />
        <TestimonialsSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}
